type StatusMessageProps = {
  tone?: "info" | "success" | "warning" | "danger";
  title?: string;
  children: React.ReactNode;
};

export function StatusMessage({ tone = "info", title, children }: StatusMessageProps) {
  return (
    <div className={`status-message status-message--${tone}`} role={tone === "danger" ? "alert" : "status"}>
      {title ? <strong>{title}</strong> : null}
      <div>{children}</div>
    </div>
  );
}
